<script setup lang="ts">
import { mdiLoading, mdiPencil, mdiPencilOff, mdiWindowClose } from '@mdi/js'
import BaseButton from '@/shared/components/button/BaseButton.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title: string
  edit?: boolean
  read?: boolean
  loading?: boolean
}

interface Emits {
  (e: 'close'): void
}

defineProps<Props>()
defineEmits<Emits>()
</script>

<template>
  <div class="relative py-4 mx-4">
    <div class="inline-flex text-nowrap items-center absolute top-0 inset-0">
      <div class="font-medium text-lg text-gray-700 pr-2">{{ title }}</div>
      <div class="border-t border-gray-300 w-full"></div>
    </div>
    <div class="flex items-center justify-end relative">
      <slot></slot>
      <template v-if="edit">
        <BaseButton
          :title="read ? $t('common.edit') : $t('common.cancel')"
          class="border-l border-y border-gray-300 text-sm p-2 hover:bg-gray-100"
          :class="read ? 'bg-white' : 'shadow-inner bg-gray-100'"
          :disabled="loading"
          @click="$emit('close')"
        >
          <SvgIcon v-if="loading" :path="mdiLoading" class="animate-spin fill-gray-700 w-5 h-5" />
          <SvgIcon v-else :path="read ? mdiPencil : mdiPencilOff" class="fill-gray-700 w-5 h-5" />
        </BaseButton>
      </template>
      <BaseButton
        :title="$t('common.close')"
        class="peer bg-white border border-gray-300 text-sm p-2 enabled:hover:bg-gray-100"
        @click="$emit('close')"
      >
        <SvgIcon :path="mdiWindowClose" class="w-5 h-5" />
      </BaseButton>
    </div>
  </div>
</template>
